import { useMutation } from '@tanstack/react-query';

import { requestAccountDeletion as requestAccountDeletionEndpoint } from '@/services/api/users';

export const useRequestAccountDeletion = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: requestAccountDeletionEndpoint,
  });

  return {
    requestAccountDeletion: mutateAsync,
    isPending,
  };
};
